import React, { Component } from 'react';
import { MapPin } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { WA_NUMBER } from '../data/products';
export function HeroSection() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Vi la oferta 20% OFF y quiero pedir mis suplementos')}`;
  return <section className="bg-gradient-to-br from-[#1a1500] via-[#0d0d0d] to-[#1a1500] pt-[100px] px-5 pb-[100px] text-center relative overflow-hidden" data-id="element-157">
      {/* Radial glow effect */}
      <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(ellipse_at_center,rgba(212,160,23,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-158" />

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-159">
        <div className="inline-flex items-center gap-1.5 bg-alphaGold text-white text-[0.8rem] font-extrabold tracking-[3px] py-1.5 px-4 rounded-sm uppercase mb-8" data-id="element-160">
          <MapPin className="w-3.5 h-3.5" data-id="element-161" /> Montevideo · Suplementos Deportivos
        </div>

        <h1 className="text-[clamp(2.2rem,6vw,4.2rem)] font-black leading-[1.1] uppercase tracking-[2px] mb-8" data-id="element-162">
          Para de <span className="text-alphaGold" data-id="element-163">Perder el Tiempo</span>
          <br data-id="element-164" />
          y Empieza a Ver
          <br data-id="element-165" />
          <span className="text-alphaGold" data-id="element-166">Resultados Reales</span>
        </h1>

        <p className="text-[clamp(1rem,2.5vw,1.3rem)] text-[#bbb] max-w-[720px] mx-auto mb-[50px] leading-[1.7]" data-id="element-167">
          Dejá de entrenar horas y no ver cambios. Los suplementos correctos —
          al precio correcto — marcan la diferencia que tu cuerpo necesita.{' '}
          <strong className="text-white" data-id="element-168">Hoy con 20% OFF.</strong>
        </p>

        <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 bg-whatsapp text-white text-[1.1rem] font-extrabold py-[18px] px-10 rounded uppercase tracking-[1px] transition-all duration-200 shadow-[0_6px_30px_rgba(37,211,102,0.35)] hover:-translate-y-[3px] hover:shadow-[0_10px_40px_rgba(37,211,102,0.5)]" data-id="element-169">
          <WhatsAppIcon className="w-[22px] h-[22px]" data-id="element-170" />
          Pedir por WhatsApp Ahora
        </a>
      </div>
    </section>;
}